export const LACT = {
  ADD_TO_LIST: {
    id: 0,
    action: 'ADD_TO_LIST',
    title: 'Add to list',
    icon: 'add-to-list-grey-icon',
  },
  REMOVE_FROM_LIST: {
    id: 1,
    action: 'REMOVE_FROM_LIST',
    title: 'Remove from list',
    icon: 'remove-from-list-grey-icon',
  },
};
